export enum DetailedPriceActions {
    SET_ACTIVE_DETAILED_PRICE = "setActiveDetailedPrice",
    SET_DETAILED_PRICE = "setSelectedDetailedPrice",
    REMOVE_DATA = "removeDetailedPriceData",
    ACCEPT_DETAILED_PRICE = "acceptDetailedPrice",
    CANCEL_DETAILED_PRICE = "cancelDetailedPrice",
    RELOAD = "reloadDetailedPrice",
  }